// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2spNc","blue":"style_blue__2LNKm"};